module.exports = __webpack_public_path__ + "static/media/error-code-panel-background.8ca64ace.png";